{
  "generic|:error": "Ett fel inträffade",
  "generic|:error-occurred": "Ett fel inträffade: {{message}}",
  "generic|:error-occurred__plural": "Ett fel inträffade: {{message}} och {{count}} andra fel",
  "generic|:error-occured-contact-support": "Ett fel har uppstått. Försök igen senare. Kontakta support om problemet kvarstår.",
  "generic|:forbidden": "Du saknar åtkomst till denna operation",
  "generic|:not-found": "Den begärda resursen existerar inte",
  "generic|:user-not-found": "Det finns ingen användare med denna e-postadress",
  "generic|:user-already-participating": "Denna användare deltar redan",
  "generic|:relation-not-found": "En eller flera relaterade resurser existerar inte",
  "generic|:unauthorized": "Du saknar behörighet att utföra operationen",
  "generic|:unauthorized-space": "Du saknar behörighet att utföra operationen i det här utrymmet",
  "assignment-group|:name-already-exists": "En annan grupp med det namnet finns redan.",
  "learning|:requires-event": "Minst en plats krävs för att skapa en händelse",
  "learning|:location|:capacity-reached": "Det saknas lediga platser till händelsen",
  "learning|:location|:already-enrolled": "Du är redan registrerad på händelsen",
  "learning|:location|:new-event-capacity-less-than-enrollments": "Det nya antalet platser är för lågt för att få plats med alla deltagare",
  "uploads|:invalid-elearning-zip": "Zipfilen innehåller ett e-lärande som är ogiltigt eller som inte stöds",
  "learnifier|:participant-limit-reached": "Maximalt deltagarantal uppnått"
}
